import DataTable from "react-data-table-component";

interface Props {
    columns: any;
    data: any;
    paginationTotalRows?: number;
    onChangePage?: (page: number) => void;
    onChangeRowsPerPage?: (perPage: number, page: number) => void;
    onSort?: (column: any, sortDirection: any) => void;
    rowsPerPage?: number;

    selectableRows?: boolean;
    onSelectedRowsChange?: (selectedRows: { selectedRows: any[] }) => void;
    selectableRowsHighlight?: boolean;
    paginationDefaultPage?: number;
    progressPending?: boolean;
    conditionalRowStyles?: any[];
}

export const ESDataTable = (props: Props) => {

    const {
        columns,
        data,
        paginationTotalRows,
        onChangeRowsPerPage,
        onChangePage,
        onSort,
        rowsPerPage,
        selectableRows,
        onSelectedRowsChange,
        selectableRowsHighlight,
        paginationDefaultPage,
        progressPending
    } = props;

    return (
        <>
            <DataTable
                columns={columns}
                data={data}
                highlightOnHover
                fixedHeader
                pagination
                paginationServer
                paginationTotalRows={paginationTotalRows}
                onChangeRowsPerPage={onChangeRowsPerPage}
                onChangePage={onChangePage}
                sortServer
                onSort={onSort}
                paginationPerPage={rowsPerPage ? rowsPerPage : Number(localStorage.getItem('PageRecordLimit'))}
                selectableRows={selectableRows}
                onSelectedRowsChange={onSelectedRowsChange}
                selectableRowsHighlight={selectableRowsHighlight}
                paginationDefaultPage={paginationDefaultPage}
                conditionalRowStyles={props.conditionalRowStyles}
            />
        </>
    );
};
 